<div [class]="!isMobile ? 'booble-backdrop' : ''">
  <div [class]="!isMobile ? 'xp-modal xp-modal-cadastro' : ''">
    <div
      [class]="
        !isMobile
          ? 'modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm'
          : ''
      "
    >
      <div class="modal-content">
        <div [class]="!isMobile ? 'modal-dialog-scrollable-general' : ''">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">
                  {{
                    boobleModalData?.isEdit ? "Editar contato" : "Novo contato"
                  }}
                </div>
                <p class="p-text-grey font-weight-300 mg-top-8">
                  Insira as informações do seu beneficiário ou pagador para
                  facilitar suas operações
                </p>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div [class]="isMobile ? '' : 'modal-body'">
            <div class="container-modal mg-top-24">
              <span class="text-choice mg-top-16"> Tipo de contato: </span>

              <mat-radio-group
                class="mg-top-16 mb-3 radios-btns"
                [(ngModel)]="contactType"
                aria-label="Selecione uma opção"
              >
                <mat-radio-button value="SENDER">
                  <p class="p-text-grey">Pagador no exterior</p>
                </mat-radio-button>
                <mat-radio-button value="BENEFICIARY">
                  <p class="p-text-grey">Beneficiário no exterior</p>
                </mat-radio-button>
              </mat-radio-group>

              <form *ngIf="contactType === 'SENDER'" [formGroup]="senderForm">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Nome do pagador</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="senderReceiverName"
                        required
                      />
                      <mat-error
                        *ngIf="
                          senderForm.get('senderReceiverName')?.touched &&
                          senderForm
                            .get('senderReceiverName')
                            ?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>E-mail</mat-label>
                      <input
                        matInput
                        type="email"
                        formControlName="email"
                        required
                      />
                      <mat-error *ngIf="senderForm.get('email')?.touched">
                        <ng-container
                          *ngIf="senderForm.get('email')?.hasError('email')"
                        >
                          E-mail inválido
                        </ng-container>
                        <ng-container
                          *ngIf="senderForm.get('email')?.hasError('required')"
                        >
                          Campo obrigatório
                        </ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>País do beneficiário</mat-label>
                      <mat-select formControlName="country">
                        <mat-option
                          *ngFor="let country of countries"
                          [value]="country"
                        >
                          {{ country.description }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          senderForm.get('country')?.touched &&
                          senderForm.get('country')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Moeda</mat-label>
                      <mat-select formControlName="currency">
                        <mat-option
                          *ngFor="let moeda of moedasInbound"
                          [value]="moeda"
                        >
                          <img [src]="moeda.image" width="20px" height="20px" />
                          <span class="ml-2">{{ moeda.description }}</span>
                        </mat-option>
                        <mat-select-trigger>
                          <mat-icon
                            [svgIcon]="senderForm.get('currency')?.value?.icon"
                          ></mat-icon>
                          <span class="ml-2">{{
                            senderForm.get("currency")?.value?.description
                          }}</span>
                        </mat-select-trigger>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          senderForm.get('currency')?.touched &&
                          senderForm.get('currency')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </form>

              <form
                *ngIf="contactType === 'BENEFICIARY'"
                [formGroup]="beneficiaryForm"
              >
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Nome do beneficiário</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="senderReceiverName"
                        required
                      />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('senderReceiverName')?.touched &&
                          beneficiaryForm
                            .get('senderReceiverName')
                            ?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>E-mail</mat-label>
                      <input
                        matInput
                        type="email"
                        formControlName="email"
                        required
                      />
                      <mat-error *ngIf="beneficiaryForm.get('email')?.touched">
                        <ng-container
                          *ngIf="
                            beneficiaryForm.get('email')?.hasError('required')
                          "
                        >
                          Campo obrigatório
                        </ng-container>
                        <ng-container
                          *ngIf="
                            beneficiaryForm.get('email')?.hasError('email')
                          "
                        >
                          E-mail inválido
                        </ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>País do beneficiário</mat-label>
                      <mat-select formControlName="country">
                        <mat-option
                          *ngFor="let country of countries"
                          [value]="country"
                        >
                          {{ country.description }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('country')?.touched &&
                          beneficiaryForm.get('country')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Moeda</mat-label>
                      <mat-select formControlName="currency">
                        <mat-option
                          *ngFor="let moeda of moedas"
                          [value]="moeda"
                        >
                          <img [src]="moeda.image" width="20px" height="20px" />
                          <span class="ml-2">{{ moeda.description }}</span>
                        </mat-option>
                        <mat-select-trigger>
                          <mat-icon
                            [svgIcon]="
                              beneficiaryForm.get('currency')?.value?.icon
                            "
                          ></mat-icon>
                          <span class="ml-2">{{
                            beneficiaryForm.get("currency")?.value?.description
                          }}</span>
                        </mat-select-trigger>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('currency')?.touched &&
                          beneficiaryForm.get('currency')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Banco</mat-label>
                      <input matInput formControlName="name" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('name')?.touched &&
                          beneficiaryForm.get('name')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>FFC</mat-label>
                      <input matInput formControlName="fcc" required />
                      <mat-error
                        *ngIf="beneficiaryForm.get('fcc')?.hasError('required')"
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'number')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Número da conta</mat-label>
                      <input matInput formControlName="number" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('number')?.touched &&
                          beneficiaryForm.get('number')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'swift')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>SWIFT</mat-label>
                      <input matInput formControlName="swift" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('swift')?.touched &&
                          beneficiaryForm.get('swift')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'iban')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>IBAN</mat-label>
                      <input matInput formControlName="iban" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('iban')?.touched &&
                          beneficiaryForm.get('iban')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'aba')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>ABA</mat-label>
                      <input matInput formControlName="aba" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('aba')?.touched &&
                          beneficiaryForm.get('aba')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'blz')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>BLZ</mat-label>
                      <input matInput formControlName="blz" />
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'cbu')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>CBU</mat-label>
                      <input matInput formControlName="cbu" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('cbu')?.touched &&
                          beneficiaryForm.get('cbu')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'cuit')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>CUIT</mat-label>
                      <input matInput formControlName="cuit" />
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'bsb')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>BSB</mat-label>
                      <input matInput formControlName="bsb" />
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="
                      shouldShowField(beneficiaryForm, 'institutionNumber')
                    "
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Institution Number</mat-label>
                      <input
                        matInput
                        formControlName="institutionNumber"
                        required
                      />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('institutionNumber')?.touched &&
                          beneficiaryForm
                            .get('institutionNumber')
                            ?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'transit')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Transit</mat-label>
                      <input matInput formControlName="transit" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('transit')?.touched &&
                          beneficiaryForm.get('transit')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-6"
                    *ngIf="shouldShowField(beneficiaryForm, 'address')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Endereço</mat-label>
                      <input matInput formControlName="address" required />
                      <mat-error
                        *ngIf="
                          beneficiaryForm.get('address')?.touched &&
                          beneficiaryForm.get('address')?.hasError('required')
                        "
                      >
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'cable')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Cable</mat-label>
                      <input matInput formControlName="cable" />
                    </mat-form-field>
                  </div>

                  <div
                    class="col-md-4"
                    *ngIf="shouldShowField(beneficiaryForm, 'sortCode')"
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Sort Code</mat-label>
                      <input matInput formControlName="sortCode" />
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="modal-footer-new">
            <button
              type="button"
              class="btn-footer btn btn-block"
              *ngIf="!boobleModalData?.isEdit"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="onSubmit()"
              [disabled]="
                contactType === 'SENDER'
                  ? !senderForm.valid || isCurrencyUnchanged
                  : !beneficiaryForm.valid
              "
            >
              Adicionar contato
            </button>

            <button
              type="button"
              class="btn-footer btn btn-block"
              *ngIf="boobleModalData?.isEdit"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              [disabled]="
                contactType === 'SENDER'
                  ? !senderForm.valid
                  : !beneficiaryForm.valid
              "
              (click)="onSubmit()"
            >
              Atualizar contato
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
